import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, AttachFile as AttachFileIcon, } from "@mui/icons-material";
import { TableCell, TableRow, Checkbox, Tooltip, Box } from "@mui/material"
import { ActionPerformed } from "../../../../shared_elements/components";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import UploadingIcon from "../../../../shared_elements/components/UploadingIcon";
import { dateMonthYearDateFormat } from "../../../../constants";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from "react";
import AuditPopover from "../../../../shared_elements/components/popover";

const WetLeaseList = ({ uploadedFileData, slug, uploadFileProgressData, viewFileStatus, item, onView, onDelete, viewRevisonHistory, onEdit, bulk, toggleBulkOps, viewFile }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Wet Lease Listing', page_type: page_type, })
    }

    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['D'] }}>
                        <Checkbox disableRipple style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className="revision-history" fontSize="small" color="primary" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['R'] }}>
                    <Tooltip title="View">
                            <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['U'] }}>
                    <Tooltip title="Edit">
                            <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['D'] }}>
                    <Tooltip title="Delete">
                            <DeleteIcon fontSize="small" color="error" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon')}} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count"> ({item.attachments.length}) </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                    </PermissionWrapper>
                { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.name?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.name ? item.name : "--"} lessMr='name' /></div></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.start_date? moment(item?.start_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.end_date ? moment(item?.end_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.details?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.details ? item.details:"--"} lessMr='details' /></div></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.remarks?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.remarks ? item.remarks:"--"} lessMr='remarks' /></div></TableCell>
        </TableRow>
    )
}
export default WetLeaseList;
